// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-right-section{\n  width: 100%;\n  background-color:red;\n}", "",{"version":3,"sources":["webpack://src/components/Layout/index.css"],"names":[],"mappings":"AAEA;EACI,WAAW;EACX,oBAAoB;AAExB","sourcesContent":["\n\n.layout-right-section{\n    width: 100%;\n    background-color:red;\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
